import { alpha } from '@mui/material';
const usePCheckboxGroupStyles = () => {
    return {
        root: {
            width: '100%',
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            borderRadius: '14px',
            background: (theme) => theme.palette.common.grey8,
            padding: 1.5,
            minHeight: '53px'
        },
        label: {
            fontSize: '14px',
            fontWeight: 500,
            color: 'text.primary',
            mb: 0.5
        },
        listContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        itemContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        optionLabel: {
            fontSize: '14px',
            fontWeight: 400,
            color: (theme) => theme.palette.text.secondary
        }
    };
};
export default usePCheckboxGroupStyles;
